import { http } from '../utils/axios';
import { TPaginationResponse, IOrdersGetData } from 'shared/types';
import {
  ILabOrder,
  ICreateUpdateLabOrder
} from 'shared/interfaces/labOrder.interface';

class LabOrderService {
  private static instance: LabOrderService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): LabOrderService {
    if (!LabOrderService.instance) {
      LabOrderService.instance = new LabOrderService();
    }

    return LabOrderService.instance;
  }

  getLabOrders = async (payload: IOrdersGetData) => {
    const { data } = await http<TPaginationResponse<ILabOrder[]>>({
      url: '/labOrders',
      method: 'GET',
      params: payload
    });

    return data;
  };

  getLabOrder = async (id: string) => {
    const { data } = await http<ILabOrder>({
      url: `/labOrders/${id}`,
      method: 'GET'
    });

    return data;
  };

  createLabOrder = async (payload: ICreateUpdateLabOrder) => {
    const { data } = await http<ILabOrder>({
      url: '/labOrders',
      method: 'POST',
      data: payload
    });
    return data;
  };

  updateLabOrder = async (payload: ICreateUpdateLabOrder) => {
    const { data } = await http<ILabOrder>({
      url: `/labOrders/${payload.labOrderId}`,
      method: 'PUT',
      data: payload
    });
    return data;
  };
}

const instance = LabOrderService.getInstance();

export default instance;
